import { lazy, Suspense } from 'react';
import type { TFlowGraph } from '@hookpipe/contracts/flows/schemas/flow-graph.schema';

import { LoadingState } from '../../../shared/ui/states';
import type { TNodeTypeDescriptor } from '../../../widgets/flow-canvas';

// xyflow is heavy; a dynamic import keeps it out of the chunk every Flows-list
// visitor loads, same reasoning as the dev-flow-kit route.
const FlowCanvasLazy = lazy(async () => {
  const mod = await import('../../../widgets/flow-canvas');
  return { default: mod.FlowCanvas };
});

interface IOneStepPreviewProps {
  graph: TFlowGraph;
  descriptors: readonly TNodeTypeDescriptor[];
}

export const OneStepPreview = ({ graph, descriptors }: IOneStepPreviewProps) => (
  <div className="mx-auto h-flow-preview-h w-flow-preview overflow-hidden rounded-control border border-border-raised">
    <Suspense fallback={<LoadingState rows={1} className="h-full" />}>
      <FlowCanvasLazy graph={graph} descriptors={descriptors} readOnly />
    </Suspense>
  </div>
);
